import {Component} from '@angular/core';

@Component({
    selector: 'app-help-faq',
    templateUrl: './help-faq.component.html',
    styleUrls: ['./help-faq.component.css']
})
export class HelpFaqComponent {
    scrollToSection(sectionId: string): void {
        const section = document.getElementById(sectionId);
        if (!section) {
            return;
        }
        section.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
}
